module.exports = __webpack_public_path__ + "fonts/7694dc270cbfd2aa0991787890d45fdf.svg";